import React from 'react';
import { Box } from '../..';
const GettingStartedLayout = ({
  children,
  ...props
}) => {
  return /*#__PURE__*/React.createElement(Box, {
    sx: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, children);
};
GettingStartedLayout.displayName = "GettingStartedLayout";
export default GettingStartedLayout;